<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Ship" subTitle="Forms" />

    <CreateVessel />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateVessel from "@/components/Pages/Master/Vessel/CreateVessel.vue";

export default defineComponent({
  name: "CreateVesselPage",
  components: {
    PageTitle,
    CreateVessel,
  },
});
</script>
